import PrivateLayout from '@/layouts/PrivateLayout.vue';
import DashboardPage from '@/pages/DashboardPage.vue';

export default [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    component: PrivateLayout,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: DashboardPage,
      },
    ],
    meta: { requiresAuth: true },
  },
];
